import { Skeleton } from "@chakra-ui/skeleton";

function Gray50Skeleton(option: any) {
  return <Skeleton startColor="#F5F5F5" endColor="#E9E9E9" {...option} />;
}

export default Gray50Skeleton;
